import { createSelector } from '@reduxjs/toolkit';
import { GlobalState } from 'reducers/stateTypes';
import { DlmState } from 'reducers/dlmReducer';

export const selectDlmStatus = createSelector(
  (state: GlobalState) => state.dlm,
  (dlmState: DlmState) => dlmState.dlmStatus,
);

export const selectTargetDlmStatus = createSelector(
  (state: GlobalState) => state.dlm,
  (dlmState: DlmState) => dlmState.targetDlmStatus,
);

export const selectTargetDlmVersion = createSelector(
  (state: GlobalState) => state.dlm,
  (dlmState: DlmState) => dlmState.targetDlmVersion,
);

export const selectDlmVersion = createSelector(
  (state: GlobalState) => state.dlm,
  (dlmState: DlmState) => dlmState.dlmVersion,
);
